// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled product section
export const ProductDetailsContainer = styled.div`
    /* Appearance */
    background-color: white;
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;

    /* Size */
    width: 90%;
    max-width: 1200px;

    /* Spacing */
    padding: 50px;
    gap: 30px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);

    /* Mobile setup */
    @media (max-width: 600px) {
        width: 85vw;
        gap: 7px;

        padding: 15px;
    }
`;

// Styled product title
export const ProductTitle = styled.h1``;

// Styled product description
export const ProductDescription = styled.p`
    /* Element disposition */
    align-self: flex-start;

    /* Spacing */
    margin-left: 50px;
    margin-right: 50px;

    /* Mobile setup */
    @media (max-width: 600px) {
        margin-left: 3vw;
        margin-right: 3vw;
    }
`;

// Styled product price
export const ProductPrice = styled.p`
    /* Element disposition */
    align-self: flex-end;

    /* Spacing */
    margin-right: 50px;

    /* Mobile setup */
    @media (max-width: 600px) {
        margin-right: 3vw;
    }
`;

// Update buttons
export const EditButton = styled.button`
    align-self: flex-end;

    margin-left: auto;
    margin-right: 2vw;

    /* Events */
    cursor: pointer;

    /* Mobile setup */
    @media (max-width: 600px) {
        margin-top: 3vw;
        margin-right: 3vw;
    }
`;

// Edit Icon
export const Icon = styled.svg`
    /* Appearance */
    fill: ${colors.primaryBeige};

    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;
